import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message } from 'antd';
import JSZip from 'jszip';
import { FC, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import { create_track } from '../services/api.service';
import { APIAnswer } from '../types';
import './importtracks.scss';

/* -------------------------------------------------------------------------------- *\
|                               PreviewFile
\* -------------------------------------------------------------------------------- */
class PreviewFile
{
    public name: string = "";
    public content: string = "";
    public selected: boolean = false;
    public message: string = "";
    public working: boolean = false;
    public done: boolean = false;
}
/* -------------------------------------------------------------------------------- *\
|                               ImportTrackssPage
\* -------------------------------------------------------------------------------- */
export const ImportTracksPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const [previewfiles, setPreviewFiles] = useState<PreviewFile[]>([]);
    const navigate = useNavigate();
    const [inputfilekey, setinputfilekey] = useState<string>('key_0');
    const [working, setworking] = useState<boolean>(false);

    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true);
        setLoading(false);
        // eslint-disable-next-line
    }, [])

    /* -------------------------------------------------------------------------------- *\
    |                               handleUpload
    \* -------------------------------------------------------------------------------- */
    async function handleUpload(event)
    {
        const e: HTMLInputElement = event.target;
        if (e.files && e.files[0])
        {
            const f: File = e.files[0];

            try
            {
                const zip = await (new JSZip()).loadAsync(f);
                const fileEntries = Object.keys(zip.files)
                    .map(key => ({ key, file: zip.file(key) }))
                    .filter(f => f.file && !f.file.dir);

                const files: PreviewFile[] = await Promise.all(
                    fileEntries.map(async f => {
                        const o = new PreviewFile();
                        o.name = f.key.split('/').pop() as string;
                        o.content = f.file ? await f.file.async('text') : "";
                        return o;
                    })
                );
                files.sort((a, b) => a.name.localeCompare(b.name));
                setPreviewFiles(files);
            }
            catch (error: unknown)
            {
                console.log(error);
            }
            setinputfilekey(inputfilekey.split('_')[0] + '_' + (parseInt(inputfilekey.split('_')[1]) + 1));
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               selectall
    \* -------------------------------------------------------------------------------- */
    function selectall()
    {
        for(const f of previewfiles)
        {
            f.selected = true;
        }
        setPreviewFiles([...previewfiles]);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               deselectall
    \* -------------------------------------------------------------------------------- */
    function deselectall()
    {
        for(const f of previewfiles)
        {
            f.selected = false;
        }
        setPreviewFiles([...previewfiles]);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               onFinishUpload
    \* -------------------------------------------------------------------------------- */
    function onFinishUpload()
    {
        const selected: PreviewFile[] = previewfiles.filter(f => f.selected);
        if (selected.length === 0)
        {
            message.error("Please select at least one file");
            return;
        }
        setworking(true);

        for(const p of previewfiles)
        {
            p.done = false;
        }
        const interval = setInterval(() =>
        {
            if (selected.find(f => f.working)) return;

            const fpf = selected.find(f => !f.done);
            if (fpf)
            {
                const els: string[] = fpf.name.split('_');
                if (els.length >= 4)
                {
                    const sic = els[0];
                    const code = els[1];
                    const type = els[2];
                    const distance = parseInt(els[3]);

                    fpf.working = true;
                    fpf.message = "creating track...";
                    setPreviewFiles([...previewfiles]);

                    create_track(sic, code, distance, type, fpf.content)
                    .then((answer: APIAnswer) =>
                    {
                        if (answer.status)
                        {
                            fpf.message = "import succeded";
                        }
                        else
                        {
                            fpf.message = answer.message;
                        }
                    })
                    .catch((error) => {  fpf.message = error; })
                    .finally(() => { fpf.working = false; fpf.done = true; setPreviewFiles([...previewfiles]); });
                }
                else
                {
                    fpf.done = true;
                    fpf.message = "Invalid file name";
                    setPreviewFiles([...previewfiles]);
                }
            }
            else
            {
                clearInterval(interval);
                setworking(false);
            }
        }, 500);
    }

    return (
        <LayoutSite>
            <div className="importtracks">
                {loading ? <Loader /> : <></>}
                <div className="importtracks__header">
                    <div>
                        <button className="importtracks__header__back" onClick={() => navigate("/tracks")}>
                            <ArrowLeftOutlined />
                            back
                        </button>
                    </div>
                </div>
                <div className="importtracks__body">
                    <div className="importtracks__body__title">Import tracks</div>
                    <Form name="importtracks__body__form" className="importtracks__body__form" onFinish={() => onFinishUpload()}>
                        <Form.Item label='File'>
                            <Input type="file" hidden={true} onChange={handleUpload} key={inputfilekey}/>
                        </Form.Item>
                        <Form.Item className="importtracks__body__form__toolbar">
                            <Button type="primary" htmlType="submit">Import</Button>
                        </Form.Item>
                    </Form>
                    {
                        previewfiles.length > 0 &&
                        <>
                            <div className='importtracks__body__preview__buttons'>
                                <Button size='small' onClick={() => selectall()} disabled={working}>Select all</Button>
                                <Button size='small' onClick={() => deselectall()} disabled={working}>Deselect all</Button>
                                <Button size='small' disabled={working} onClick={() => document.querySelector('form#importtracks__body__form')?.dispatchEvent(new MouseEvent('submit', { bubbles: true, cancelable: true }))}>Import</Button>
                                {
                                    working &&
                                    <div className='importtracks__body__preview__buttons__blinking'>Creating tracks...</div>
                                }
                            </div>
                            <div className='importtracks__body__preview'>
                                <div className='importtracks__body__preview__files'>
                                    {
                                        previewfiles?.map((file: PreviewFile, index) =>
                                        {
                                            return (
                                                <>
                                                    <div key={'file_' + index + '_check'}><Checkbox checked={file.selected} onChange={(e) => { file.selected = e.target.checked; setPreviewFiles([...previewfiles]); }} /></div>
                                                    <div key={'file_' + index + '_name'}>{file.name}</div>
                                                    <div key={'file_' + index + '_msg'}>{file.message}</div>
                                                </>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </LayoutSite>
    );
}
